import { render, staticRenderFns } from "./ChatNotify.vue?vue&type=template&id=38917bd6&scoped=true&"
import script from "./ChatNotify.vue?vue&type=script&lang=js&"
export * from "./ChatNotify.vue?vue&type=script&lang=js&"
import style0 from "./ChatNotify.vue?vue&type=style&index=0&id=38917bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38917bd6",
  null
  
)

export default component.exports